import { PureQueryOptions, RefetchQueriesFunction } from '@apollo/client';
import { IconComponentProps } from '@bechtel/gds';
import { CommodityMilestone, CrewMemberAssignment } from '@bechtel/types';
import { MilestoneStatusExt } from '../types';

export interface MilestoneAttachmentActionProps {
  status: MilestoneStatusExt;
  milestone: CommodityMilestone;
  isInverted?: boolean;
}

export interface MilestoneActionProps {
  milestone: CommodityMilestone;
  status: MilestoneStatusExt;
  actionText?: string;
  openBlockSidesheet?: () => void;
  disabled?: boolean;
  refetchQueries?: (string | PureQueryOptions)[] | RefetchQueriesFunction;
  customStyle?: React.CSSProperties;
  onActionUpdating?: () => void;
  onActionCompleted?: () => void;
  isUserClaimer?: boolean;
}
export interface MilestoneStyledProps {
  isBlocked?: boolean;
  isInverted?: boolean;
  status: MilestoneStatusExt;
  onClick?: () => void;
}

export interface MilestoneActionContentProps {
  label: string;
  icon: IconComponentProps['icon'];
}

export interface MilestoneNonActionProps {
  label: string;
  icon: IconComponentProps['icon'];
}
